//load our custom elements
/*
import Sidechain from '@nprapps/sidechain';
const guest = Sidechain.registerGuest({ sentinel: 'st' });

guest.sendMessage({
        type: 'analytics',
        eventCategory: 'interaction',
        eventAction: 'click',
        eventLabel: 'etc'
    });
*/

require("component-leaflet-map");


//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var data = require("./taco.geo.json");
data.features.sort((a, b) => a.properties.order - b.properties.order);

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

var onEachFeature = function(feature, layer) {
	layer.bindPopup(ich.popup(feature.properties))
  
};

 map.scrollWheelZoom.disable();

 function geojsonMarkerOptions(feature) {

  return {
    radius: 10,
    // fillColor: getColor(feature.properties.type),
    fillColor: "#cc5500",
    color: "#ffffff",
    weight: 1,
    opacity: 1,
    fillOpacity: 0.6
  }
};

var geojson = L.geoJson(data, {
    pointToLayer: function (feature, latlng) {
        
        return L.circleMarker(latlng);
        
    },
    style: geojsonMarkerOptions,
    onEachFeature: onEachFeature
}).addTo(map);

map.fitBounds(geojson.getBounds());